import { render, staticRenderFns } from "./templateDetail.vue?vue&type=template&id=3f6e6dd7&scoped=true"
import script from "./templateDetail.vue?vue&type=script&lang=js"
export * from "./templateDetail.vue?vue&type=script&lang=js"
import style0 from "./templateDetail.vue?vue&type=style&index=0&id=3f6e6dd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6e6dd7",
  null
  
)

export default component.exports